module.exports = __webpack_public_path__ + "fonts/Figtree-430.c0c8c34.woff2";